export default {
    baseApiURL: 'https://universityeducationfair.co.uk/api/',
    baseURL: 'https://universityeducationfair.co.uk/'
}